import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackEvent} from '../../tracking/amplitude/TrackingV2';
import {DeclarativeMutationConfig} from 'relay-runtime/lib/mutations/RelayDeclarativeMutationConfig';
import {Disposable, Environment} from 'relay-runtime';
import {
	DeleteClientBillToInput,
	DeleteClientBillToMutation,
	DeleteClientBillToMutation$rawResponse,
} from './__generated__/DeleteClientBillToMutation.graphql';
import {omit} from 'lodash';

const mutation = graphql`
	mutation DeleteClientBillToMutation($input: DeleteClientBillToInput!) @raw_response_type {
		deleteClientBillTo(input: $input) {
			deletedClientBillToId
		}
	}
`;

function getConfigs(input): DeclarativeMutationConfig[] {
	return [
		{
			type: 'RANGE_DELETE',
			parentID: input.clientId,
			connectionKeys: [
				{
					key: 'Client_clientBillTos',
				},
			],
			pathToConnection: ['client', 'clientBillTos'],
			deletedIDFieldName: 'deletedClientBillToId',
		},
	];
}

function getOptimisticResponse(input: DeleteClientBillToInput): DeleteClientBillToMutation$rawResponse {
	return {
		deleteClientBillTo: {
			deletedClientBillToId: input.clientBillToId,
		},
	};
}

function commit(
	environment: Environment,
	input: DeleteClientBillToInput,
	onSuccess?: (response) => void,
	onError?: (error: Error) => void
): Disposable {
	trackEvent('Client Bill To', 'Deleted', input);

	const cleanedInput = omit(input, ['clientId']) as Omit<DeleteClientBillToInput, 'clientId'>;

	const variables = {
		input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...cleanedInput},
	};

	return commitMutation<DeleteClientBillToMutation>(environment, {
		mutation,
		variables,
		configs: getConfigs(input),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
